import { API_ENDPOINT } from "@config/consts";

const getApiUrl = (fallbackUrl = API_ENDPOINT): string => {
  return fallbackUrl;
};

export { getApiUrl };
